import axios from "axios";
import { pivotApiUrl } from "../redux/live-suggestion/liveSuggestionSlice";

const MISS = "That price did not load.";

export function marketQuote(text) {
  const raw = String(text || "").trim();
  if (/^(analys(?:e|is)|check)\b/i.test(raw)) return null;
  const body = raw.replace(/^price\s+/i, "").trim();
  if (/[\u0600-\u06FF]/.test(body)) {
    if (!/^[\u0600-\u06FF\u200c\s]{2,30}$/.test(body) || body.split(/\s+/).length > 3) return null;
    return pivotQuote(body);
  }
  const named = raw.match(/^price\s+(\S+)$/i);
  if (!named) return null;
  return pivotQuote(named[1]);
}

function pivotQuote(symbol) {
  return axios
    .post(pivotApiUrl({ action: "quote", symbol }), { action: "quote", symbol })
    .then((res) => res?.data?.message || MISS)
    .catch(() => MISS);
}
